import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Declarar a função gtag_report_conversion do Google Ads
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleWhatsApp = () => {
    // Registrar conversão do Google Ads antes de abrir o WhatsApp
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.open('https://wa.me/5519981868997', '_blank');
  };

  const handleCall = () => {
    // Registrar conversão do Google Ads antes de fazer a ligação
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.location.href = 'tel:+5519981868997';
  };

  return (
    <>
      <header className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <button
              onClick={() => handleNavigation('/')}
              className="flex items-center cursor-pointer"
            >
              <img
                alt="Desentupidora da Cidade Nº1"
                className="w-16 h-16 object-contain mr-3"
                src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/7b868c287da1d35a6e81793ece1ec769.png"
              />
              <div>
                <h1 className="text-2xl font-bold text-gray-800">Desentupidora da Cidade Nº1</h1>
              </div>
            </button>

            <nav className="hidden lg:flex items-center space-x-8">
              <button
                onClick={() => handleNavigation('/')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Home
              </button>
              <button
                onClick={() => handleNavigation('/sobre-nos')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Sobre Nós
              </button>
              <button
                onClick={() => handleNavigation('/servicos')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Serviços
              </button>
              <button
                onClick={() => handleNavigation('/vantagens')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Vantagens
              </button>
              <button
                onClick={() => handleNavigation('/contato')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Contato
              </button>
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <button
                onClick={handleCall}
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2 whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                <span>(19) 98186-8997</span>
              </button>
              <button
                onClick={handleWhatsApp}
                className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors flex items-center space-x-2 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                <span>WhatsApp</span>
              </button>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </div>
            </button>
          </div>
        </div>

        <div className="md:hidden bg-gradient-to-r from-blue-600 to-blue-700 text-white py-2">
          <div className="container mx-auto px-4">
            <div className="flex items-center justify-center text-sm">
              <button
                onClick={handleWhatsApp}
                className="flex items-center space-x-2 cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
                <span>WhatsApp</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-40 bg-white">
          <div className="container mx-auto px-4 py-8">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => handleNavigation('/')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left py-2"
              >
                Home
              </button>
              <button
                onClick={() => handleNavigation('/sobre-nos')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left py-2"
              >
                Sobre Nós
              </button>
              <button
                onClick={() => handleNavigation('/servicos')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left py-2"
              >
                Serviços
              </button>
              <button
                onClick={() => handleNavigation('/vantagens')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left py-2"
              >
                Vantagens
              </button>
              <button
                onClick={() => handleNavigation('/contato')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left py-2"
              >
                Contato
              </button>
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
